import { FormEvent, useState } from "react";
import type { InviteCreateResult } from "../api/client";

interface AdminInvitePanelProps {
  onCreateInvite: (email: string) => Promise<InviteCreateResult>;
}

export function AdminInvitePanel({ onCreateInvite }: AdminInvitePanelProps) {
  const [email, setEmail] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [result, setResult] = useState<InviteCreateResult | null>(null);
  const [error, setError] = useState<string | null>(null);

  async function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    setIsLoading(true);
    setError(null);
    setResult(null);
    try {
      const invite = await onCreateInvite(email.trim());
      setResult(invite);
      setEmail("");
    } catch (err) {
      setError(err instanceof Error ? err.message : "invite_failed");
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <div className="admin-invite">
      <button className="icon-button" type="button" onClick={() => setIsOpen((value) => !value)}>
        邀请用户
      </button>
      {isOpen ? (
        <form className="admin-invite-popover" onSubmit={handleSubmit}>
          <div>
            <p className="popover-title">邀请新用户</p>
            <p className="popover-copy">发送注册链接，对方设置密码后即可使用。</p>
          </div>
          <label>
            邀请邮箱
            <input
              type="email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              placeholder="name@example.com"
              required
            />
          </label>
          <button className="primary-button compact" type="submit" disabled={isLoading}>
            {isLoading ? "发送中..." : "发送邀请"}
          </button>
          {result ? (
            <div className="invite-result">
              <p>{result.email_sent ? "邀请邮件已发送。" : "邀请已创建，但邮件未发送。"}</p>
              {result.email_error ? <small>原因：{result.email_error}</small> : null}
              <a href={result.invite_url} target="_blank" rel="noreferrer">
                打开邀请链接
              </a>
            </div>
          ) : null}
          {error ? <p className="form-error">{error}</p> : null}
        </form>
      ) : null}
    </div>
  );
}
